import PropTypes from 'prop-types';

// material
// import { alpha, styled } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import { Box, Grid, Toolbar, Typography } from '@mui/material';

// components
//
import './Footer.css';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import VisaMastercard from '../../assets/VisaMastercard.png';
// ----------------------------------------------------------------------

const APPBAR_MOBILE = 84;
const APPBAR_DESKTOP = 190;

const RootStyle = styled('footer')(({ theme }) => ({
  boxShadow: 'none',
  // position: 'absolute',
  bottom: '0',
  // backdropFilter: 'blur(6px)',
  // WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  // backgroundColor: alpha(theme.palette.background.paper, 1),
  backgroundColor: 'transparent',
  width: '100%',
  maxWidth: '1440px',
  [theme.breakpoints.up('xs')]: {
    width: `100%`,
    padding: '0px'
  },
  [theme.breakpoints.up('sm')]: {
    width: `100%`,
    padding: '5px 10px'
  }

  // background:
  //   'linear-gradient(0deg, rgba(255,255,255,0.2987570028011205) 0%, rgba(9,121,13,0.5032387955182073) 50%, rgba(255,255,255,0.3) 100%);'
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('xs')]: {
    alignItems: 'start',
    minHeight: APPBAR_MOBILE,
    padding: '10px 10px 60px'
  },
  [theme.breakpoints.up('sm')]: {
    minHeight: APPBAR_DESKTOP,
    alignItems: 'center',
    padding: '10px 10px 70px'
  },
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    alignItems: 'center',
    padding: '10px 10px 70px'
  }
}));

// ----------------------------------------------------------------------

Footer.propTypes = {
  onOpenSidebar: PropTypes.func
};

export default function Footer() {
  const navigate = useNavigate();
  const language = useSelector((state) => state.Intl.locale);
  const userData = useSelector((state) => state.global.userData);
  return (
    <RootStyle>
      <div className="visit-card-footer-bg">
        <ToolbarStyle>
          <Grid container spacing={0}>
            <Grid item xs={12} sm={12} lg={4}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: { xs: 'center', sm: 'center', lg: 'start' },
                  mb: { xs: '25px', sm: '25px', lg: '0px' },
                  alignItems: 'center',
                  width: '100%'
                }}
              >
                <div
                  className="footer-logo"
                  onClick={() => {
                    navigate(`/`);
                  }}
                ></div>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} lg={4} sx={{ mb: { xs: 2 } }}>
              <div>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: { xs: 'center', sm: 'center', lg: 'start' }
                  }}
                >
                  <a
                    className="footer-address-text"
                    href={`/${language}/agreement`}
                    rel="noreferrer"
                    style={{ marginBottom: '15px' }}
                  >
                    Користувальницька угода
                  </a>
                  <a
                    className="footer-address-text"
                    href={`/${language}/about`}
                    rel="noreferrer"
                    style={{ marginBottom: '15px' }}
                  >
                    Про нас
                  </a>
                  {!userData?.id && !window.location.href.includes('support') && (
                    <a
                      className="footer-address-text"
                      href={`/${language}/support`}
                      rel="noreferrer"
                    >
                      Підтримка
                    </a>
                  )}
                </Box>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} lg={4}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  alignItems: { xs: 'center', sm: 'center', lg: 'end' },
                  width: '100%',
                  height: '100%'
                }}
              >
                <img width={200} src={VisaMastercard} alt="VisaMastercardIcon" />
                <Typography
                  sx={{
                    fontSize: { xs: '16px', sm: '20px' },
                    fontFamily: 'FixelText-Medium !important',
                    color: 'black',
                    mt: { xs: 2, sm: 2, lg: 0 }
                  }}
                >
                  © Всі права захищені ТОВ «Б&Б Рішення»
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </ToolbarStyle>
      </div>
    </RootStyle>
  );
}
